import { ComponentLoader } from '@bythepixel/component-loader';
import Accordion from '@Core/components/accordion';
import asyncIframe from '@Core/components/asyncIframe';
import Background from '@Core/components/background';
import CareersGridCard from '@Core/components/careersGridCard';
import CheckboxSelect from '@Core/components/checkboxSelect';
import CopyCurrentUrl from '@Core/components/copyCurrentUrl';
import ComplyAutoController from '@Core/components/complyAutoController';
import FavoriteCounter from '@Core/components/favoriteCounter';
import FavoriteButton from '@Core/components/favoriteButton';
import FavoriteBanner from '@Core/components/favoriteBanner';
import FinancingCalculator from '@Core/components/financingCalculator';
import FloatingElementManager from '@Core/components/floatingElementManager';
import Form from '@Core/components/form';
import FormSelect from '@Core/components/formSelect';
import Geolocator from '@Core/components/geolocator';
import InViewAni from '@Core/components/inViewAni';
import InViewSrc from '@Core/components/inViewSrc';
import InViewSrcset from '@Core/components/inViewSrcset';
import InViewStyle from '@Core/components/inViewStyle';
import LazyloadIframe from '@Core/components/lazyloadIframe';
import LeadForm from '@Core/components/leadForm';
import Marquee from '@Core/components/marquee';
import Modal from '@Core/components/microModalAdpt';
import VehicleCard from '@Core/components/vehicleCard';
import VehicleCardGrid from '@Core/components/vehicleCardGrid';
import PaginationLinks from '@Core/components/paginationLinks';
import PartCard from '@Core/components/partCard';
import VehicleSearch from '@Core/components/vehicleSearch';
import { ReviewCarousel, TextFeatureController } from '@Core/components/kenect';
import {
  SectionBasicLogoSlider,
  SectionBlogSlider,
  SectionCorporateLogoSlider,
  SectionImageSliderWithCaptions,
  SectionTestimonialSlider,
  SectionBlogPromoSlider,
  SectionCardSlider,
  SectionGeneralSlider,
  SectionHeroSlider,
  SectionMediaGallerySlider,
  SectionVehicleCardsMobileSlider,
  SectionVehicleSlider,
  SectionModalVehicleSlider,
  SocialGallery,
} from '@Core/components/sliders';
import VehicleTypeSubNav from '@Core/components/splide/vehicleTypeSubNav';
import RippleClick from '@Core/components/rippleClick';
import SectionHeaderCareersScroll from '@Core/components/sectionHeaderCareersScroll';
import SectionProductSpecs from '@Core/components/sectionProductSpecs';
import SectionStickySubNav from '@Core/components/sectionStickySubNav';
import SectionSubModels from '@Core/components/sectionSubModels';
import SectionSubNavHomepage from '@Core/components/sectionSubNavHomepage';
import SectionSubNavProductDetails from '@Core/components/sectionSubNavProductDetails';
import SnackbarController from '@Core/components/snackbarController';
import StickyContainer from '@Core/components/stickyContainer';
import StickyTable from '@Core/components/stickyTable';
import SubNav from '@Core/components/subNav';
import SectionTabs from '@Core/components/sectionTabs';
import SectionFeatures from '@Core/components/sectionFeatures';
import StatsCount from '@Core/components/statsCount';
import CollapsibleText from '@Core/components/collapsibleText';
import Tinymce from '@Core/components/tinymce';
import SubModelModal from '@Core/components/subModelModal';
import YoutubeFacetedSearch from '@Core/components/youtubeFacetedSearch';
import YoutubeLivestream from '@Core/components/youtubeLivestream';
import DigitalCallTreeButton from '@Core/components/digitalCallTreeButton';
import DigitalCallTree from '@Core/components/digitalCallTree';
import LocationSearchField from '@Core/components/locationSearchField';
import Dialog from '@Core/components/dialog';

window.globalComponents = new ComponentLoader(document, [
  SnackbarController,
  Accordion,
  asyncIframe,
  Background,
  CareersGridCard,
  CheckboxSelect,
  ComplyAutoController,
  CopyCurrentUrl,
  Dialog,
  DigitalCallTree,
  DigitalCallTreeButton,
  FavoriteCounter,
  FavoriteButton,
  FavoriteBanner,
  FinancingCalculator,
  FloatingElementManager,
  Form,
  FormSelect,
  Geolocator,
  TextFeatureController,
  InViewAni,
  InViewSrc,
  InViewSrcset,
  InViewStyle,
  LazyloadIframe,
  LeadForm,
  LocationSearchField,
  Marquee,
  Modal,
  PaginationLinks,
  PartCard,
  SectionBasicLogoSlider,
  SectionBlogSlider,
  SectionCorporateLogoSlider,
  SectionImageSliderWithCaptions,
  SectionTestimonialSlider,
  SectionBlogPromoSlider,
  SectionCardSlider,
  SectionFeatures,
  SectionGeneralSlider,
  SectionHeroSlider,
  SectionMediaGallerySlider,
  SectionSubNavHomepage,
  SectionSubNavProductDetails,
  SectionModalVehicleSlider,
  SocialGallery,
  SectionProductSpecs,
  SectionVehicleCardsMobileSlider,
  SectionVehicleSlider,
  SubModelModal,
  ReviewCarousel,
  RippleClick,
  VehicleSearch,
  SectionHeaderCareersScroll,
  SectionStickySubNav,
  SectionSubModels,
  SectionTabs,
  StatsCount,
  StickyContainer,
  StickyTable,
  SubNav,
  CollapsibleText,
  Tinymce,
  VehicleCard,
  VehicleCardGrid,
  VehicleTypeSubNav,
  YoutubeFacetedSearch,
  YoutubeLivestream,
]);
